export default __webpack_public_path__ + "static/media/doctor.2f0d62ae.svg";